import React, { useEffect, useRef, useState } from "react";
import "./HotelModifyNew.css";
import { Container, Row, Col, ProgressBar } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { hotelSearch } from "../../../redux/services/operations/hotel";
import HotelModifyForm from "./HotelModifyForm";
import HotelFiltering from "./HotelFiltering";
import HotelListingModifyNew from "./HotelListingModifyNew";
import HotelMobileFilters from "./HotelMobileFilters";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import Star from "./HotelFilter/Star";
import Price from "./HotelFilter/Price";
import Meals from "./HotelFilter/Meals";
import FIlter from "./HotelFilter/FIlter";
import Sort from "./HotelFilter/Sort";

function HotelModifyNew() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const search = useSelector((state) => state.hotel.hotelSearch);

  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [paginatedHotels, setPaginatedHotels] = useState([]);
  const [pagesData, setPagesData] = useState([]);

  const [selectedStars, setSelectedStars] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedFacilities, setSelectedFacilities] = useState([]);
  const [selectedRoomTypes, setSelectedRoomTypes] = useState([]);
  const [selectedMealPlans, setSelectedMealPlans] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredHotels, setFilteredHotels] = useState([]);

  const [minFare, setMinFare] = useState(0);
  const [maxFare, setMaxFare] = useState(0);
  const [sliderValue, setSliderValue] = useState([0, 0]);

  const [sortOption, setSortOption] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const params = new URLSearchParams(location.search);
  const city = params.get("city");
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const from = params.get("from");
    const city = params.get("city");
    const startDate = params.get("startDate");
    const endDate = params.get("endDate");
    const roomsParam = params.get("rooms");

    const roomsArray = roomsParam ? JSON.parse(roomsParam) : [];
    setRooms(roomsArray);
    setPaginatedHotels([]);
    setPagesData([]);

    const pax = roomsArray
      .map((room) => {
        const parts = [room.adults || 0, room.children || 0];
        if (Array.isArray(room.childrenAges)) {
          parts.push(...room.childrenAges);
        }
        return parts.join("_");
      })
      .join("?");

    const makeRequestData = (page) => ({
      city: from,
      Rooms: roomsArray.length.toString(),
      cin: startDate,
      cOut: endDate,
      pax: pax,
      page,
    });

    let active = true;
    let firstBatchLoaded = false;
    let safetyCounter = 0;

    const fetchUntilEmpty = async (page = 1, accumulated = []) => {
      if (!active) return;

      if (!firstBatchLoaded) {
        setLoading(true);
      }

      try {
        const hotels = await dispatch(
          hotelSearch(makeRequestData(page), navigate)
        );

        if (!active) return;

        const batch = Array.isArray(hotels) ? hotels : [];

        if (!firstBatchLoaded) {
          setLoading(false);
          firstBatchLoaded = true;
        }

        if (batch.length === 0) {
          return; // stop looping when API returns empty array
        }

        const newAccumulated = [...accumulated, ...batch];
        setPaginatedHotels(newAccumulated);
        setPagesData((prev) => [...prev, { page, hotels: batch }]);

        safetyCounter += 1;
        if (safetyCounter < 100 && active) {
          setTimeout(() => {
            if (active) {
              fetchUntilEmpty(page + 1, newAccumulated);
            }
          }, 300); // Increased delay to 300ms to help prevent 429 errors
        }
      } catch (err) {
        console.error("Batch fetch error:", err);
        if (active) setLoading(false);
      }
    };

    fetchUntilEmpty(1, []);

    return () => {
      active = false;
    };
  }, [location.search, dispatch, navigate]);

  useEffect(() => {
    const hotelListLocal = Array.isArray(paginatedHotels)
      ? paginatedHotels
      : [];

    const prices = hotelListLocal
      .map((h) => h.Rooms?.[0]?.TotalFare)
      .filter((p) => typeof p === "number");

    if (prices.length > 0) {
      const min = Math.floor(Math.min(...prices));
      const max = Math.ceil(Math.max(...prices));
      setMinFare(min);
      setMaxFare(max);
      setSliderValue([min, max]);
    }
  }, [paginatedHotels]);

  const hotelList = Array.isArray(paginatedHotels) ? paginatedHotels : [];

  const allStars = [
    ...new Set(hotelList.map((h) => Number(h.star_rating))),
  ].sort((a, b) => b - a);

  const allLocations = [
    ...new Set(
      hotelList.map((h) => {
        const parts = h.address?.split(",") || [];
        return parts[parts.length - 3]?.trim() || h.city;
      })
    ),
  ];

  const allFacilities = [
    ...new Set(
      hotelList.flatMap((h) =>
        h.Rooms?.flatMap((r) =>
          (r.Inclusion || "").split("|").map((f) => f.trim())
        )
      )
    ),
  ].filter(Boolean);

  const allRoomTypes = [
    ...new Set(
      hotelList.flatMap((h) =>
        h.Rooms?.flatMap((r) =>
          (r.Name?.[0] || "").split(",").map((x) => x.trim())
        )
      )
    ),
  ].filter(Boolean);

  const allMealPlans = [
    ...new Set(
      hotelList.flatMap((h) =>
        h.Rooms?.map((r) => (r.MealType || "").toLowerCase().replace(/ /g, "-"))
      )
    ),
  ].filter(Boolean);

  const handleToggle = (value, state, setter) => {
    const newState = state.includes(value)
      ? state.filter((item) => item !== value)
      : [...state, value];
    setter(newState);
  };

  const clearAll = () => {
    setSearchQuery("");
    setSelectedStars([]);
    setSelectedLocations([]);
    setSelectedFacilities([]);
    setSelectedRoomTypes([]);
    setSelectedMealPlans([]);
    setSliderValue([minFare, maxFare]);
    setSortOption("");
  };

  const applyFilters = () => {
    const filtered = hotelList.filter((h) => {
      const firstRoom = h.Rooms?.[0];
      const fare = firstRoom?.TotalFare;

      if (
        typeof fare !== "number" ||
        fare < sliderValue[0] ||
        fare > sliderValue[1]
      )
        return false;

      if (
        debouncedQuery &&
        !h.name?.toLowerCase().includes(debouncedQuery.toLowerCase())
      )
        return false;

      if (
        selectedStars.length &&
        !selectedStars.includes(Number(h.star_rating))
      )
        return false;

      if (
        selectedLocations.length &&
        !selectedLocations.some((loc) => h.address?.includes(loc))
      )
        return false;

      if (
        selectedFacilities.length &&
        !h.Rooms?.some((r) =>
          selectedFacilities.every((fac) =>
            (r.Inclusion || "").toLowerCase().includes(fac.toLowerCase())
          )
        )
      )
        return false;

      if (
        selectedRoomTypes.length &&
        !h.Rooms?.some((r) =>
          selectedRoomTypes.every((rt) =>
            (r.Name?.[0] || "")
              .toLowerCase()
              .split(",")
              .map((s) => s.trim())
              .includes(rt.toLowerCase())
          )
        )
      )
        return false;

      if (
        selectedMealPlans.length &&
        !h.Rooms?.some((r) =>
          selectedMealPlans.includes(
            (r.MealType || "").toLowerCase().replace(/ /g, "-")
          )
        )
      )
        return false;

      return true;
    });

    let sorted = [...filtered];
    if (sortOption === "Low to High") {
      sorted.sort(
        (a, b) =>
          (a.Rooms?.[0]?.TotalFare || Infinity) -
          (b.Rooms?.[0]?.TotalFare || Infinity)
      );
    } else if (sortOption === "High to Low") {
      sorted.sort(
        (a, b) =>
          (b.Rooms?.[0]?.TotalFare || 0) - (a.Rooms?.[0]?.TotalFare || 0)
      );
    } else if (sortOption === "popularity") {
      sorted.sort(
        (a, b) => (Number(b.star_rating) || 0) - (Number(a.star_rating) || 0)
      );
    }

    setFilteredHotels(sorted);
  };

  useEffect(() => {
    applyFilters();
  }, [
    debouncedQuery,
    selectedStars,
    selectedLocations,
    selectedFacilities,
    selectedRoomTypes,
    selectedMealPlans,
    sliderValue,
    sortOption,
    search,
    paginatedHotels,
  ]);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedQuery(searchQuery), 300);
    return () => clearTimeout(t);
  }, [searchQuery]);

  const [openFilter, setOpenFilter] = useState(null);
  const filterRef = useRef(null);

  const toggleFilter = (name) => {
    setOpenFilter((prev) => (prev === name ? null : name));
  };
  const closeFilter = () => {
    setOpenFilter(null);
  };

  // Detect outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setOpenFilter(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      <HotelModifyForm />

      {/* Progress Bar for Hotel Search */}
      {/* {loading && (
        <div className="hotel-search-progress-container">
          <Container>
            <div className="hotel-search-progress-wrapper">
              <div className="progress-text">
                <h5>Searching for hotels...</h5>
                <p>Please wait while we find the best deals for you</p>
              </div>
              <ProgressBar
                now={progress}
                animated
                variant="primary"
                className="hotel-search-progress-bar"
                style={{ height: "8px", borderRadius: "4px" }}
              />
              <div className="progress-percentage">{Math.round(progress)}%</div>
            </div>
          </Container>
        </div>
      )} */}

      <div className="hotelmodifydropdown_main dropdown_main">
        <Container>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="hotelavailbility">
              {filteredHotels.length} Hotels Available in {city}
            </div>

            <div className="hotelmodifyinputs_wrapper">
              <div className="inputWrapper">
                <input
                  type="text"
                  className="hotelmodifyinput"
                  placeholder="Search hotels..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              <div className="hotelmodifydropdown">
                <select
                  id="sortOptions"
                  className="hotelmodifyselect"
                  value={sortOption}
                  onChange={(e) => setSortOption(e.target.value)}
                >
                  <option value="">-- Sort By --</option>
                  <option value="popularity">Popularity</option>
                  <option value="Low to High">Low to High</option>
                  <option value="High to Low">High to Low</option>
                </select>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <Container>
        <section className="hotellist_fliter">
          <Row>
            <Col lg={3} md={3} sm={12}>
              <HotelFiltering
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                selectedStars={selectedStars}
                selectedLocations={selectedLocations}
                selectedFacilities={selectedFacilities}
                selectedRoomTypes={selectedRoomTypes}
                selectedMealPlans={selectedMealPlans}
                search={search}
                handleToggle={handleToggle}
                setSelectedStars={setSelectedStars}
                setSelectedLocations={setSelectedLocations}
                setSelectedFacilities={setSelectedFacilities}
                setSelectedRoomType={setSelectedRoomTypes}
                setSelectedMealPlans={setSelectedMealPlans}
                allMealPlans={allMealPlans}
                allRoomTypes={allRoomTypes}
                allFacilities={allFacilities}
                allLocations={allLocations}
                allStars={allStars}
                hotelList={hotelList}
                clearAll={clearAll}
                maxFare={maxFare}
                minFare={minFare}
                sliderValue={sliderValue}
                setSliderValue={setSliderValue}
              />
            </Col>
            <Col lg={9} md={9} sm={12}>
              <HotelListingModifyNew
                hotel={filteredHotels}
                loading={loading}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                selectedStars={selectedStars}
                selectedLocations={selectedLocations}
                selectedFacilities={selectedFacilities}
                selectedRoomTypes={selectedRoomTypes}
                selectedMealPlans={selectedMealPlans}
                search={search}
                handleToggle={handleToggle}
                setSelectedStars={setSelectedStars}
                setSelectedLocations={setSelectedLocations}
                setSelectedFacilities={setSelectedFacilities}
                setSelectedRoomType={setSelectedRoomTypes}
                setSelectedMealPlans={setSelectedMealPlans}
                allMealPlans={allMealPlans}
                allRoomTypes={allRoomTypes}
                allFacilities={allFacilities}
                allLocations={allLocations}
                allStars={allStars}
                hotelList={hotelList}
                clearAll={clearAll}
                maxFare={maxFare}
                minFare={minFare}
                sliderValue={sliderValue}
                setSliderValue={setSliderValue}
              />
              <HotelMobileFilters toggleFilter={toggleFilter} />
            </Col>
          </Row>
        </section>
      </Container>

      {openFilter === "rating" && (
        <Star
          setSelectedStars={setSelectedStars}
          handleToggle={handleToggle}
          closeFilter={closeFilter}
          clearAllFilters={clearAll}
          selectedStars={selectedStars}
          allStars={allStars}
        />
      )}

      {openFilter === "price" && (
        <Price
          handleToggle={handleToggle}
          closeFilter={closeFilter}
          clearAllFilters={clearAll}
          maxFare={maxFare}
          minFare={minFare}
          sliderValue={sliderValue}
          setSliderValue={setSliderValue}
        />
      )}
      {openFilter === "facility" && (
        <Meals
          handleToggle={handleToggle}
          closeFilter={closeFilter}
          clearAllFilters={clearAll}
          setSelectedFacilities={setSelectedFacilities}
          allFacilities={allFacilities}
          selectedFacilities={selectedFacilities}
        />
      )}

      {openFilter === "filter" && (
        <FIlter
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          closeFilter={closeFilter}
          selectedStars={selectedStars}
          selectedLocations={selectedLocations}
          selectedFacilities={selectedFacilities}
          selectedRoomTypes={selectedRoomTypes}
          selectedMealPlans={selectedMealPlans}
          search={search}
          handleToggle={handleToggle}
          setSelectedStars={setSelectedStars}
          setSelectedLocations={setSelectedLocations}
          setSelectedFacilities={setSelectedFacilities}
          setSelectedRoomType={setSelectedRoomTypes}
          setSelectedMealPlans={setSelectedMealPlans}
          allMealPlans={allMealPlans}
          allRoomTypes={allRoomTypes}
          allFacilities={allFacilities}
          allLocations={allLocations}
          allStars={allStars}
          hotelList={hotelList}
          clearAll={clearAll}
          maxFare={maxFare}
          minFare={minFare}
          sliderValue={sliderValue}
          setSliderValue={setSliderValue}
        />
      )}
      {/* closeFilter={closeFilter} clearAllFilters={clearAll}  */}
      {openFilter === "sort" && (
        <Sort
          closeFilter={closeFilter}
          sortOption={sortOption}
          setSortOption={setSortOption}
        />
      )}
    </div>
  );
}

export default HotelModifyNew;
